import { useSocialRiskQueryParams } from '../../../hooks/useSocialRiskQueryParams'
import { useProfileAnalysisFilters } from '../../../hooks/useProfileAnalysisFilters'
import { SocialHazardsWidget } from '../widgets/SocialHazardsWidget'
import { SocialDemographicWidget } from '../widgets/SocialDemographicWidget'
import { SocialAreaWidget } from '../widgets/SocialAreaWidget'
import { SocialAreaScatterWidget } from '../widgets/SocialAreaScatterWidget'
import type { PropertiesMetricOption } from '../../../types/riskProfileProperties.types'

const RESIDENTS_METRIC_OPTION: PropertiesMetricOption = {
  value: 'population',
  metric: 'population',
  type: 'total',
  label: 'Residents exposed',
}

export function SocialAnalysis() {
  const {
    selectedWorkspace,
    areaGroup,
    areas,
    selectedHazardGroups,
    selectedAreaTypesLabel,
    damageStates,
  } = useProfileAnalysisFilters()

  const socialQueryParams = useSocialRiskQueryParams({
    selectedWorkspace,
    areaGroup,
    areas,
    selectedHazardGroups,
    demographicView: 'age',
    damageStates,
  })

  const hasAreaContext = areaGroup !== '' || areas.length > 0

  return (
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
      <SocialDemographicWidget
        selectedWorkspace={selectedWorkspace}
        areaGroup={areaGroup}
        areas={areas}
        selectedHazardGroups={selectedHazardGroups}
        damageStates={damageStates}
      />

      <SocialHazardsWidget queryParams={socialQueryParams} metricOption={RESIDENTS_METRIC_OPTION} />

      <SocialAreaScatterWidget
        queryParams={socialQueryParams}
        metricOption={RESIDENTS_METRIC_OPTION}
      />

      {hasAreaContext && (
        <SocialAreaWidget
          queryParams={socialQueryParams}
          metricOption={RESIDENTS_METRIC_OPTION}
          selectedAreaTypesLabel={selectedAreaTypesLabel}
        />
      )}
    </div>
  )
}
